module.exports = __webpack_public_path__ + "img/logo-firpo.ca70a7bc.svg";